import { render, staticRenderFns } from "./treasury_details.vue?vue&type=template&id=e7dc5f8c&"
import script from "./treasury_details.vue?vue&type=script&lang=js&"
export * from "./treasury_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports